export type TransientStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>
export function useTransientStorage(): TransientStorage {
  if (typeof window === 'undefined') throw new Error('Session storage is only accessible when running in a browser.')
  return window.sessionStorage
}
